import { SvgIcon } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import React from 'react';

type HelixIconSizes = 0.25 | 0.5 | 1 | 1.5 | 2 | 2.5 | 3 | 3.5 | 4;

enum HelixIconType {
  Helix,
  MUI,
}
type HelixIconProps = {
  rem?: HelixIconSizes;
  color?: SvgIconProps['color'];
  type?: HelixIconType;
  sx?: SvgIconProps['sx'];
};

// We probably don't even need this component. We could use a template to wrap our SVGs in this.
// https://react-svgr.com/docs/custom-templates/
const HelixIcon: React.FC<HelixIconProps> = ({ rem = 1, color, type = HelixIconType.Helix, sx, children }) => (
  <SvgIcon
    color={color}
    fontSize="inherit"
    // Helix icons use strokes while MUI icons use fill. If you set fill: "none" for a MUI icon it will be invisible.
    sx={{ fill: type === HelixIconType.Helix ? 'none' : undefined, fontSize: `${rem}rem`, ...sx }}
    inheritViewBox
  >
    {children}
  </SvgIcon>
);

export { HelixIcon as default, HelixIcon, HelixIconType };
export type { HelixIconProps, HelixIconSizes };
